import { useEffect } from 'react';
import Bugsnag from '@bugsnag/js';
import { Paths } from '../../config/routes';
import { redirecTo } from '../../utils';
import MessageError from '../message-error';
import styles from './styles.module.scss';
import { Button } from '../common/button';
import { useTranslation } from 'react-i18next';

const ErrorView = () => {
  const { t } = useTranslation();
  useEffect(() => {
    Bugsnag.notify(new Error('General error page was displayed.'));
  }, []);

  return (
    <div className={styles.error_view} onClick={() => redirecTo(Paths.CHECKOUT)}>
      <MessageError />
      <div className={styles.error_view_btn}>
        <Button onClick={() => redirecTo(Paths.CHECKOUT)}>{t('common.return')}</Button>
      </div>
    </div>
  );
};

export default ErrorView;
